'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveId$() {
  this.c5n = null;
  this.c5o = false;
  this.c5l = null;
  this.c5m = false;
}
export { $c_Lpresto_types$DirectiveId$ as $c_Lpresto_types$DirectiveId$ };
$p = $c_Lpresto_types$DirectiveId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveId$;
/** @constructor */
function $h_Lpresto_types$DirectiveId$() {
}
export { $h_Lpresto_types$DirectiveId$ as $h_Lpresto_types$DirectiveId$ };
$h_Lpresto_types$DirectiveId$.prototype = $p;
$p.adv = (function() {
  if ((!this.c5o)) {
    this.c5n = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.c5o = true;
  }
  return this.c5n;
});
$p.v3 = (function() {
  if ((!this.c5m)) {
    this.c5l = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c5m = true;
  }
  return this.c5l;
});
var $d_Lpresto_types$DirectiveId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveId$, "presto.types$DirectiveId$", ({
  Zu: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveId$ as $d_Lpresto_types$DirectiveId$ };
var $n_Lpresto_types$DirectiveId$;
function $m_Lpresto_types$DirectiveId$() {
  if ((!$n_Lpresto_types$DirectiveId$)) {
    $n_Lpresto_types$DirectiveId$ = new $c_Lpresto_types$DirectiveId$();
  }
  return $n_Lpresto_types$DirectiveId$;
}
export { $m_Lpresto_types$DirectiveId$ as $m_Lpresto_types$DirectiveId$ };
//# sourceMappingURL=presto.types$-Directive-Id$.js.map
